<template>
    <div class="mod--row mod--row-flex mod--row-middle date-input-header"
         style="justify-content: center; margin-right: calc(1.25rem - 2px);margin-bottom: 0.5em; border: 1px solid #5E544A;">
        <div class="col">
            <button :class="`icon icon--chevron-left subtract-day-arrow ${isAtMinimum?'hidden':''}`"
                    v-on:click="changeDateMinus"></button>
        </div>
        <div style="flex:1;display:flex;justify-content: center;align-items: center">
            <DateInput class="mod--header-picker" v-model="date" :min-date="minDate"/>
        </div>
        <div class="col">
            <button class="icon icon--chevron-right" style="padding: 12px" v-on:click="changeDatePlus"></button>
        </div>
    </div>
</template>

<script>
import DateInput from './date_input';
import moment from 'moment';

export default {
    name: 'DateInputHeader',
    props: ['value', 'increment', 'minDate'],
    components: {
        DateInput
    },
    computed: {
        date: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
        isAtMinimum: {
            get() {
                return this.minDate && !moment(this.minDate).isBefore(moment(this.date), 'day')
            }
        }
    },
    methods: {
        changeDateMinus: function () {
            const date = moment(this.date);
            const newDate = date.subtract(this.increment ? this.increment : 1, 'd')
            if (!this.minDate || !newDate.isBefore(moment(this.minDate))) {
                this.date = newDate.toDate();
            }
        },
        changeDatePlus: function () {
            const date = moment(this.date);
            this.date = date.add(this.increment ? this.increment : 1, 'd').toDate();
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/templates/part/item/date_input_header.vue